import { forwardRef } from 'react'

const Input = forwardRef(function Input(
  {
    label,
    error,
    hint,
    leftElement,
    rightElement,
    className = '',
    containerClassName = '',
    ...props
  },
  ref
) {
  return (
    <div className={`flex flex-col gap-1.5 ${containerClassName}`}>
      {label && (
        <label className="text-sm font-medium text-ink-secondary">
          {label}
        </label>
      )}

      <div className={`
        relative flex items-center
        bg-surface-overlay border rounded-md overflow-hidden
        transition-colors duration-150
        ${error ? 'border-siglat-red' : 'border-surface-border focus-within:border-siglat-teal'}
      `}>
        {leftElement && (
          <div className="flex items-center justify-center pl-3 text-ink-muted flex-shrink-0">
            {leftElement}
          </div>
        )}

        <input
          ref={ref}
          className={`
            flex-1 bg-transparent px-3 py-3
            text-ink-primary placeholder-ink-muted
            focus:outline-none
            disabled:opacity-50 disabled:cursor-not-allowed
            ${leftElement ? 'pl-2' : ''}
            ${rightElement ? 'pr-2' : ''}
            ${className}
          `}
          {...props}
        />

        {rightElement && (
          <div className="flex items-center justify-center pr-3 text-ink-muted flex-shrink-0">
            {rightElement}
          </div>
        )}
      </div>

      {error && (
        <p className="text-xs text-siglat-red flex items-center gap-1">
          <span>⚠</span> {error}
        </p>
      )}
      {hint && !error && (
        <p className="text-xs text-ink-muted">{hint}</p>
      )}
    </div>
  )
})

export default Input
